const MAX_PAYMENT_TERM_FILE_BYTES = 1024 * 1024;

function buildPaymentTermImportInput(content, actions = {}, applyDefaultFromFile = false) {
  return {
    content,
    conflictActions: Object.entries(actions)
      .filter(([, action]) => action === "update" || action === "skip")
      .map(([row, action]) => ({ row: Number(row), action }))
      .sort((left, right) => left.row - right.row),
    applyDefaultFromFile: applyDefaultFromFile === true,
  };
}

function paymentTermImportError(error) {
  const body = error?.response?.data;
  return (typeof body?.detail === "string" && body.detail)
    || (typeof body?.title === "string" && body.title)
    || "Die Zahlungsbedingungen konnten nicht verarbeitet werden. Bitte erneut versuchen.";
}

async function paymentTermExportError(error) {
  const body = error?.response?.data;
  if (typeof body?.text === "function") {
    try { return paymentTermImportError({ response: { data: JSON.parse(await body.text()) } }); }
    catch { return paymentTermImportError(error); }
  }
  return paymentTermImportError(error);
}

module.exports = { MAX_PAYMENT_TERM_FILE_BYTES, buildPaymentTermImportInput, paymentTermImportError, paymentTermExportError };
